import { use } from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

// eslint-disable-next-line react-hooks/rules-of-hooks
export const i18n = use(Backend)
	.use(initReactI18next)
	.init({
		lng: "en",
		fallbackLng: "en",
		interpolation: { escapeValue: false },
		// react-i18next 14's Suspense mode throws a promise from useTranslation
		// whenever a lazy-loaded namespace isn't ready yet. We don't wrap tool
		// components in <Suspense>, so that throw crashes them. Disabling
		// Suspense makes useTranslation return synchronously (with keys as
		// fallback while the namespace finishes loading).
		react: { useSuspense: false },
	})
	.catch((err) => {
		console.error("Failed to initialize i18n", err);
	});
